// format decimal values for number inputs onBlur
const formatDigits = (
	event: React.FocusEvent<any>,
	digits: number = 2
) => {
	event.target.value = parseFloat(event.target.value).toFixed(digits);
};

export default formatDigits;
